import { ReactNode } from "react";
import { styled } from "@mui/system";
import TabsUnstyled from "@mui/base/TabsUnstyled";
import { Tab, TabsList, TabPanel } from "src/components/Tabs";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import checkPermission from "src/helper/checkPermission";

interface Props {
  onFirstClick?: () => void;
  onSecondClick?: () => void;
  onThirdClick?: () => void;
  tabActive: 0 | 1 | 2;
  children: ReactNode;
}

const UserGroups = ({ tabActive, children }: Props) => {
  const navigate = useNavigate();
  return (
    <TabsUnstyled defaultValue={tabActive}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabsList>
          {checkPermission("User", "is_view") && (
            <Tab value={0} onClick={() => navigate("/users/list")}>Pengguna</Tab>
          )}
          {checkPermission("Role", "is_view") && (
            <Tab value={1} onClick={() => navigate("/users/roles")}>Role</Tab>
          )}
          {checkPermission("Store Access", "is_view") && (
            <Tab value={2} onClick={() => navigate("/users/store-access")}>
              Akses Toko
            </Tab>
          )}
        </TabsList>
      </Box>
      <TabPanel value={0}>
        <StyledBox>{tabActive === 0 && children}</StyledBox>
      </TabPanel>
      <TabPanel value={1}>
        <StyledBox>{tabActive === 1 && children}</StyledBox>
      </TabPanel>
      <TabPanel value={2}>
        <StyledBox>{tabActive === 2 && children}</StyledBox>
      </TabPanel>
    </TabsUnstyled>
  );
};

const StyledBox = styled(Box)`
  width: 100%;
  min-height: 200px;
  background: white;
  padding: 10px;
`;

export default UserGroups;
